import Vue from "vue";
import VueRouter from "vue-router";
//import Home from '../views/Home.vue'
import AllCons from "@/components/all-types-cons";
import AllExamAnalyse from "@/components/all-types-examen-analyse";
import ChoicePatient from "@/components/choicePatient";
import Consultation from "@/components/consultation";
import Dashboard from "@/components/dashboard";

import BonConsultation from "@/components/caisse/manage-bons/bon-consultation";
import BonMedical from "@/components/caisse/manage-bons/bon-medical";

import AllConsultations from "@/components/all-consultations-list";
import BonAnalyseExam from "@/components/bon-analyse-examen";
import ValiderAll from "@/components/valider-paiement-all";


import Login from "@/components/login";
import PharmacieFacture from "@/components/sans-consultations/facture-pharmacie";
import FactureSoins from "@/components/sans-consultations/facture-soins";

// -----        CAISSE          ------
import Caisse from "@/components/caisse";
import CaisseOuverture from '@/components/caisse/caisse-ouverture';
import BonSortieCaisse from '@/components/caisse/caisse-sortie-bon';
import Versement from '@/components/caisse/caisse-versement';
import Depot from '@/components/caisse/depot';
import Ventes from '@/components/caisse/vente/ventes';
import VersementsEnAttente from '@/components/caisse/versements-en-attente';
// -----------------------------------

// ---------    COMPTABLE    ------------
import Charge from '@/components/comptable/charges';
import Coupon from '@/components/comptable/coupons';
import Creance from '@/components/comptable/creance';
import TableauDeBord from '@/components/comptable/dashboard';
import ListeDemandeAnnulation from '@/components/comptable/demande-annulation';
import Dette from '@/components/comptable/dettes';
import GestionCaisse from '@/components/comptable/gestion-caisse';
import Inventaire from '@/components/comptable/inventaires';
import JournalCaisse from '@/components/comptable/journal-caisse';
import LigneBudgetaire from '@/components/comptable/ligne-budgetaire';
import Produit from '@/components/comptable/produits';
import Recouvrement from '@/components/comptable/recouvrements';


// ----------  TRESORERIE  --------------
import Dotation from '@/components/tresorerie/dotation';
import Tresorerie from '@/components/tresorerie/tresorerie';


// ------       FACTURE     --------
import FactureRembourse from '@/components/all-consultations-list/facture-rembourse';
import FactureProforma from '@/components/caisse/facture-proforma';
import Facture from '@/components/caisse/factures';
import FactureAssurance from '@/components/caisse/factures/facture-assurance';
import ManageFactureAssurance from '@/components/caisse/factures/facture-assurance/manage-facture';
import DetailRemboursement from '@/components/caisse/factures/facture-assurance/view-facture';
import PaiementOperation from '@/components/caisse/factures/paiement';
import PatientOperation from '@/components/caisse/factures/patients-operations';
import PrintBon from '@/components/caisse/factures/print-bons';
import ProFacture from '@/components/caisse/factures/pro-facture';
import DetailFacture from '@/components/caisse/factures/view-facture';

// Ticket de caisse
import SaleReceipt from '@/components/caisse/factures/ticket-caisse';

// >>> OlD FACTURES
import Factures from "@/components/all-consultations-list/factures";
import FacturesDifferees from "@/components/all-consultations-list/factures-differees";
import FacturesEnAttente from "@/components/all-consultations-list/factures-en-attente";

// --------   RELIQUAT   --------
import Reliquat from '@/components/caisse/reliquat';

// ------   PARAMETRES   --------
import BlockedUI from '@/components/blocked-ui';
import Profil from '@/components/parametres/profil';

import store from '@/store';
Vue.use(VueRouter);


const routes = [
    {
        path: '/blocked',
        name: 'Access Denied',
        component: BlockedUI,
    },

    {
        path: "/",
        name: "Index",
        redirect: "/dashboard"
    },
    {
        path: "/dashboard",
        name: "Tableau de bord",
        component: Dashboard,
    },

    {
        path: "/consultation",
        name: "Consultation",
        component: Consultation,
    },

    {
        path: "/bon-de-consultation",
        name: "Bon consultation",
        component: BonConsultation,
        props: true
    },

    {
        path: "/bon-medical",
        name: "Bon medical",
        component: BonMedical,
        props: true
    },

    {
        path: "/bon-analyse-examen",
        name: "Bon analyse examen",
        component: BonAnalyseExam,
        props: true
    },

    {
        path: "/consultations-all/factures/:bulletin_id/type_prestation/:type",
        name: "Bulletin",
        component: BonAnalyseExam,
        props: true
    },

    {
        path: "/consultations-all",
        name: "consultations-all",
        component: AllConsultations,
    },

    {
        path: "/ventes",
        name: "Vente",
        component: Ventes,
    },

    {
        path: "/ventes/facture-proforma/:proforma_id",
        name: "Proforma",
        component: Ventes,
    },

    {
        path: "/clinicaa/comptabilite/caisse",
        name: "Caisse",
        component: Caisse,
    },
    {
        path: "/clinicaa/comptabilite/caisse/ouverture",
        name: "Ouverture de Caisse",
        component: CaisseOuverture,
    },
    {
        path: "/clinicaa/comptabilite/caisse/sortie-bon",
        name: "Bon de Sortie",
        component: BonSortieCaisse,
    },
    {
        path: "/clinicaa/comptabilite/caisse/versement",
        name: "Versement",
        component: Versement,
    },
    {
        path: "/versements-en-attente",
        name: "versemen-en-attente",
        component: VersementsEnAttente,
    },
    
    {
        path: "/choice-patient",
        name: "choice-patient",
        component: ChoicePatient,
        props: true,
        //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },

    {
        path: "/valider-paiement-all/:passedConsult",
        name: "valider-paiement-all",
        component: ValiderAll,
        props: true
            //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },

    {
        path: "/factures",
        name: "Factures",
        component: Facture,
        props: true
    },

    {
        path: "/factures/ticket-caisse",
        name: "SaleReceipt",
        component: SaleReceipt,
        props: true
    },

    {
        path: "/factures/imprimer-bons",
        name: "PrintBon",
        component: PrintBon,
        props: true
    },
    
    {
        path: "/factures/patients-operations",
        name: "Patient-Operation",
        component: PatientOperation,
        props: true
    },
    
    {
        path: "/factures/paiement",
        name: "Paiement-Operation",
        component: PaiementOperation,
        props: true
    },

    {
        path: "/factures/pro-facture",
        name: "ProFacture",
        component: ProFacture,
        props: true
    },

    {
        path: "/factures/detail-facture",
        name: "DetailFacture",
        component: DetailFacture,
        props: true
    },

    {
        path: "/factures/remboursement-assurance",
        name: "FactureAssurance",
        component: FactureAssurance,
        props: true
    },
    
    {
        path: "/factures/demande-remboursement",
        name: "ManageFactureAssurance",
        component: ManageFactureAssurance,
        props: true
    },

    {
        path: "/factures/detail-remboursement",
        name: "DetailRemboursement",
        component: DetailRemboursement,
        props: true
    },

    {
        path: "/consultations-all/factures/:passedConsult",
        name: "Facture",
        component: Factures,
        props: true
    },

    {
        path: "/consultations-all/factures-differees/:passedConsult",
        name: "Facture Differees",
        component: FacturesDifferees,
        props: true
    },
    {
        path: "/consultations-all/factures-en-attentes/:passedConsult",
        name: "Facture Attentes",
        component: FacturesEnAttente,
        props: true
    },

    {
        path: "/consultations-all/factures-rembourse",
        name: "Facture Assurance",
        component: FactureRembourse,
        props: true
    },

    {
        path: "/factures/facture-proforma",
        name: "Facture proforma",
        component: FactureProforma,
    },

    {
        path: "/reliquat",
        name: "Reliquat",
        component: Reliquat,
        props: true
    },

    // display all type consultations
    {
        path: "/cons-all",
        name: "consultation-all",
        component: AllCons
    },
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: "/exam-analyse-all/:passed",
        name: "exam-analyse-all",
        component: AllExamAnalyse,
        props: true
    },

    {
        path: "/depots",
        name: "Dépôt",
        component: Depot,
    },

    // +++++++++++      COMPTABLE       +++++++++++++
    {
        path: "/charges",
        name: "Charges",
        component: Charge,
        props: true
    },
    {
        path: "/produits",
        name: "Produits",
        component: Produit,
        props: true
    },
    {
        path: "/creance",
        name: "Creance",
        component: Creance,
        props: true
    },
    {
        path: "/gestion-caisse",
        name: "Gestion de caisse",
        component: GestionCaisse,
        props: true
    },
    {
        path: "/inventaires",
        name: "Inventaires",
        component: Inventaire,
        props: true
    },
    {
        path: "/recouvrements",
        name: "Recouvrement",
        component: Recouvrement,
        props: true
    },
    {
        path: "/pharmacie-facture",
        name: "pharmacie-facture",
        component: PharmacieFacture,
        props: true
    },
    {
        path: "/facture-soins",
        name: "facture-soins",
        component: FactureSoins,
        props: true
    },
    {
        path: "/ligne-budgetaire",
        name: "Ligne Budgetaire",
        component: LigneBudgetaire,
        props: true
    },
    {
        path: "/dettes",
        name: "Dettes",
        component: Dette,
        props: true
    },
    {
        path: "/journal-caisse",
        name: "Journal de caisse",
        component: JournalCaisse,
        props: true
    },

    {
        path: "/tableau-de-bord",
        name: "Admin Board",
        component: TableauDeBord,
        props: true
    },

    {
        path: "/demande-annulation",
        name: "Demande annulation",
        component: ListeDemandeAnnulation,
        props: true
    },

    // +++++++++  TRESORERIE  ++++++++++
    {
        path: "/tresorerie",
        name: "Tresorerie",
        component: Tresorerie,
        props: true
    },
    {
        path: "/dotation",
        name: "Dotation",
        component: Dotation,
        props: true
    },
    {
        path: "/coupons",
        name: "Coupon",
        component: Coupon,
        props: true
    },
    {
        path: "/parametres/profil",
        name: "Profil",
        component: Profil,
        props: true
    },

    {
        path: "/*",
        name: "Not found",
        redirect: "/dashboard"
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
});
router.beforeEach((to, from, next) => {
    let access = false;
    let role;
    let role_actif
    if (store.getters['authInfo']) {
        role = store.getters['authInfo'].user.roles
        access = false
        for (let index = 0; index < role.length; index++) {
            
            if (
                role[index].nom == "ROLE_RECEPTIONNISTE" || 
                role[index].nom == "ROLE_COMPTABLE" || role[index].nom == "ROLE_ADMINISTRATEUR" || 
                role[index].nom == "ROLE_TRESORERIE" || role[index].nom == "ROLE_CAISSIERE"
            ) {
                if (store.getters['activeRole']) {
                    role_actif = store.getters['activeRole'].nom
                    if (
                        role_actif != 'ROLE_CAISSIERE' && 
                        role_actif != 'ROLE_COMPTABLE' && role_actif != 'ROLE_TRESORERIE' && role[index].nom == "ROLE_RECEPTIONNISTE"
                    ) {
                        if (role[index].pivot.is_active != true || role[index].pivot.is_active != '1' || role[index].pivot.is_active != 1) {
                            store.dispatch('switchRole', { userId: store.getters['authInfo'].user.id, roleId: role[index].pivot.role_id })
                        } 
                    }
                } else {
                    if (role[index].pivot.is_default == 1) {
                        store.dispatch('switchRole', { userId: store.getters['authInfo'].user.id, roleId: role[index].pivot.role_id })
                    }
                }

                access = true
                break;
            } else {
                access = false
            }
                
        }
    }

    
    if (!store.getters['authInfo'] && to.name != 'login') {
        router.push('/login')
    } else if (access === false && to.name != 'login') {
        router.push('/login')
    } else {
        // const user_info = store.getters['authInfo']
        
        // const can_login = user_info?.user.can_login
        
        // next()
        // if (can_login == null || can_login == 0) {
        //     localStorage.clear();
        //     router.push('/login')
        // } else {
        //     let countdown = {}
        //     store.dispatch('getCountDown').then((response) => {
        //         countdown = response
        //         if (countdown.is_count == 1 && countdown.duree_restant.days < 0) {
        //             router.push('/blocked')
        //         } 
        //     })
        // }


        next()

        // let countdown = {}
        // store.dispatch('getCountDown').then((response) => {
        //     countdown = response
        //     console.log("next to ",countdown);
        //     if (countdown.is_count == 1 && countdown.duree_restant.days < 0) {
        //         router.push('/blocked')
        //     } 
        // })
    }
})

export default router;